export async function fetchPublicKey() {
    const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoFmJKtby+hveAK8W37L4
JiA8I3zz43TQij5O02gwWI/Y2VXQ2qeeY1Ea/Ym2uB+dtZBucAVc4g+nXO4q0Mww
4aysrsLV3lqblBIPA9eSCivboRYnyzrtoaQyIYOZAzf5NenSqZZhbWEQK55BgLMI
XhdF4PDWZ/ZRbJrUcusAXZunRN1c1a/yGeC2LVTzLtvFGP2T3o+1DJegKeeTprQO
ECvvjASRbLvMjLLwRTGEGjsxgFxAAYTwVb9xAOVhLZMBS0b7ulJPrzO3z23PrJPJ
ylJg3PY81Tn7RNZj/U47xaaClAluTtIAQZFcAtbJN7xH67z+YgRijvDruW1UAPQV
hwIDAQAB
-----END PUBLIC KEY-----`;
    return publicKey;
}

function pemToArrayBuffer(pem) {
    const b64 = pem
        .replace(/-----BEGIN PUBLIC KEY-----/, "")
        .replace(/-----END PUBLIC KEY-----/, "")
        .replace(/\s/g, "");
    const binaryDerString = atob(b64);
    const bytes = new Uint8Array(binaryDerString.length);
    for (let i = 0; i < binaryDerString.length; i++) {
        bytes[i] = binaryDerString.charCodeAt(i);
    }
    return bytes.buffer;
}

export async function encryptRSA_OAEP(plainText) {
    const pem = await fetchPublicKey();
    const keyBuffer = pemToArrayBuffer(pem);

    const publicKey = await window.crypto.subtle.importKey(
        "spki",
        keyBuffer,
        {
            name: "RSA-OAEP",
            hash: "SHA-256",
        },
        false,
        ["encrypt"]
    );

    const encoded = new TextEncoder().encode(plainText);
    const encrypted = await window.crypto.subtle.encrypt(
        { name: "RSA-OAEP" },
        publicKey,
        encoded
    );

    return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}
